import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How Lisp changed my style",
  "description": "",
  "published": "2010-01-11T00:00:00.000Z",
  "redirect_from": ["/blog/how-lisp-changed-my-style/swizec/1074"],
  "categories": "Computer programming, food for thought, Functional programming, Languages, life, Lisp, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:IBM402plugboard.Shrigley.wireside.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/01/300px-IBM402plugboard.Shrigley.wireside.jpg",
              "alt": "IBM 402 Accounting Machine plug-board wiring. ..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:IBM402plugboard.Shrigley.wireside.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`This is the first post in the series of `}<em parentName="p">{`How `}{`<`}{`x> changed my style`}</em>{` where I shall talk about tools and events that had a significant impact on my style of doing things. If you happen to like this idea, I would be very happy if you could help it spread like wildfire, because it's a form of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Pay_it_forward",
        "title": "Pay it forward"
      }}>{`pay-it-forward`}</a>{` where we say Thanks for cool stuff.`}</p>
    <p>{`Some months ago, fuck has it been two? three? four?,`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      